export const ROUTE_PATH = {
    HOME: '/',
    GAME: '/game',
    GALLERY: '/gallery',
    LORE: '/lore',
    DOCS: '/docs'
};